import { Component, Input } from '@angular/core';
import { AbstractAuditDto, AgentDto, AuditModificationDto, AuditSessionDto, ResultListDto } from '../../../../service/dto';
import { HttpAuditService } from '../../../../service/http-audit.service';
import { OnTableChange, TableColumn } from '../../../../components/table/table.component';
import { finalize } from 'rxjs';

@Component({
	selector: 'app-agent-audit-modifications',
	standalone: false,
	templateUrl: './agent-audit-modifications.component.html',
	styleUrl: './agent-audit-modifications.component.scss'
})
export class AgentAuditModificationsComponent {
	_agent!: AgentDto;
	selectedTabIndex = 0;
	resultsByAgent!: ResultListDto<AbstractAuditDto>;
	resultsToAgent!: ResultListDto<AbstractAuditDto>;
	loading = false;

	constructor(private service: HttpAuditService) {

	}

	@Input('agent')
	set agent(input: AgentDto) {
		this._agent = input;
		this.loading = true;
		this.service.getAgentsModifications(this._agent.id, 0, 100000)
			.pipe(finalize(() => this.loading = false))
			.subscribe(results => {
				this.resultsByAgent = results;
			})
		this.service.getModificationsToAgent(this._agent.id, 0, 100000)
			.pipe(finalize(() => this.loading = false))
			.subscribe(results => {
				this.resultsToAgent = results;
			})
	}

	get agent(): AgentDto {
		return this._agent;
	}


	trackByHashCode(index: number, item: AuditSessionDto): any {
		return item.hashCode;
	}
}
